import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useCurrentFluent2Theme } from '../../../hooks/styling';
import { useInProgressToastContext } from '../hooks/toast-hooks';
import { BaseToast } from './base-toast';

const messages = defineMessages({
    spinnerAriaLabel: {
        id: 'InProgressToast_Spinner_AriaLabel',
        defaultMessage: 'Operation in progress',
        description: 'Aria label for spinner in progress operation toast',
    },
});

export const InProgressToast: React.FC = React.memo(() => {
    const { isOpen, properties, closeSurface } = useInProgressToastContext();
    const theme = useCurrentFluent2Theme();
    const { formatMessage } = useIntl();

    return (
        <BaseToast
            isOpen={isOpen}
            title={properties?.title}
            autoHideDelay={properties?.autoHideDelay}
            devBoxName={properties?.devBoxName}
            useSpinner={true}
            spinnerAriaLabel={formatMessage(messages.spinnerAriaLabel)}
            backgroundColor={theme.colorNeutralBackground3}
            onDismiss={closeSurface}
        >
            {properties?.children}
        </BaseToast>
    );
});
